export const URL_LIST_CATEGORY = "/v1/gocheckin/category/site/list?"
export const URL_ADD_CATEGORY = "/v1/gocheckin/category/form/create"
export const URL_UPDATE_CATEGORY = "/v1/gocheckin/category/form/update?"
export const URL_DELETE_CATEGORY = "/v1/gocheckin/category/form/delete?"
